import React, { Component } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { repositoryState, messageDispatcher, currentPageState, combineStates, flagState } from '../../store';
import { Message } from '..';
import { PropTypes } from 'prop-types';
import { Dialog, Snackbar, Stack } from '@mui/material';
import $ from "jquery";

export class MessagesContainerComponent extends Component {  

  constructor(props){
    super(props);
  }
  getMessages() {
    const { items } = this.props;

    if ( !items ) {
      return null;
    }

    let cartFooterLength = $(".mobile-cart-footer").outerHeight()

    let contentHeight = $("#container").outerHeight();
    let currentPage = this.props.currentPage.currentPage
    let bottom = currentPage==="categoriesPage"?"46px":(currentPage==="cartPage" || currentPage==="configuratorPage")?"15px":"-17px";
    let diff = "0px"
    diff = currentPage==="categoriesPage" && !this.props.flags.mobileSearchHeader?"108px":(currentPage==="cartPage" || currentPage==="configuratorPage" || currentPage==="modelConfiguratorPage")?currentPage==="configuratorPage"|| currentPage==="modelConfiguratorPage"?"72px":cartFooterLength+"px":"46px";
    return <Stack width="100%" sx={{height:{md:"auto", xs:`calc(${contentHeight}px - ${diff})`},padding:{md:"0px", xs:"10px"},justifyContent:{md:"center", xs:"flex-end"}, alignItems:{md:"center", xs:"center"}, position:{md:"relative", xs:"static"}, bottom:{md:"0px", xs:bottom}}}>
        {items.map( message => <Message 
            key={ message.id }
            message={ message }
            onDelete={ this.removeMessage }
            timeout={3000}
          />
      ).reverse()}
    </Stack>
  }

  removeMessage = message => this.props.removeMessage( message )

  render() {
    const className = classNames( 'messages-container', { 'static': !this.props.interactive } );
    
    return<div className={ className }>
        { this.getMessages() }
      </div>
  }
}

MessagesContainerComponent.propTypes = {
  items: PropTypes.arrayOf( PropTypes.object ), 
  removeMessage: PropTypes.func.isRequired
};

export const MessagesContainer = connect( combineStates(currentPageState,flagState, repositoryState( 'message' )), messageDispatcher )( MessagesContainerComponent );